function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #24051e;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 44.71,
  y: 1.14,
  width: 141.7,
  height: 41.34
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M186.99,249.98c0,42.22-34.35,76.56-76.56,76.56s-69.08-25.83-69.08-69.08H0c0,66.05,44.37,110.42,110.42,110.42s117.91-52.89,117.91-117.91V42.46h-41.34v207.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1190.64,242.66v-95.98h-41.34v95.98c0,66.07,53.74,119.8,119.8,119.8h42.57v-41.34h-42.57c-43.27,0-78.46-35.19-78.46-78.46Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 1365.24,
  width: 41.34,
  height: 43.63
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 1191.14,
  y: 105.9,
  width: 120.53,
  height: 41.34
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 1149.3,
  y: 0.61,
  width: 41.34,
  height: 105.87
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 1365.24,
  y: 105.86,
  width: 41.34,
  height: 255.68
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1583.75,99.89c-74.98,0-135.98,60.17-135.98,134.12s61.01,134.11,135.98,134.11,135.98-60.16,135.98-134.11-61.01-134.12-135.98-134.12ZM1583.75,326.78c-52.18,0-94.64-41.61-94.64-92.77s42.46-92.78,94.64-92.78,94.64,41.63,94.64,92.78-42.46,92.77-94.64,92.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M986.61,326.78c-52.18,0-94.64-41.61-94.64-92.77s42.46-92.78,94.64-92.78c36.24,0,69.78,20.74,85.45,52.84l37.14-18.14c-22.54-46.19-70.66-76.04-122.59-76.04-74.98,0-135.98,60.17-135.98,134.12s61.01,134.11,135.98,134.11c52.18,0,100.4-30.04,122.83-76.52l-37.23-17.98c-15.58,32.3-49.19,53.16-85.61,53.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1800.61,140.19v-34.32h-41.34v255.68l40.64.04v-.04l.7-158.6c4.94-39.09,38.24-69.34,78.67-69.34,43.84,0,79.37,35.54,79.37,79.38v148.6h41.34v-149.75c-.4-88.37-115.47-161.55-199.39-71.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M613.72,140.19v-34.32h-41.34v255.68l40.64.04v-.04l.7-158.6c4.94-39.09,38.24-69.34,78.67-69.34,43.84,0,79.37,35.54,79.37,79.38v148.6h41.34v-149.75c-.4-88.37-115.47-161.55-199.39-71.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M475.78,105.44l-.7,158.6c-4.94,39.09-38.24,69.34-78.67,69.34-43.84,0-79.37-35.54-79.37-79.38V105.4h-41.34v149.75c.4,88.37,115.47,161.55,199.39,71.64v34.32h41.34V105.44l-40.64-.04v.04Z"
})));
function SvgJunctionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 368.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunctionLogo);
export default __webpack_public_path__ + "static/media/junction_logo.157af8f026f9a376b868c25df13ac05f.svg";
export { ForwardRef as ReactComponent };